const runTestType = {
  RUN_TEST: "RUN_TEST",
  BULK_TEST: "BULK_TEST",
  SCHEDULE_TEST: "SCHEDULE_TEST",
};

export default runTestType;